require("core-js/modules/es.array.reduce.js");

var simplify = require('./simplify');

var simplifyEntity = function simplifyEntity(entity, options) {
  var type = entity.type;
  var simplified = {
    id: entity.id,
    type: type,
    modified: entity.modified
  };
  if (entity.datatype) simplified.datatype = entity.datatype;

  if (type === 'item') {
    simplifyIfDefined(entity, simplified, 'labels');
    simplifyIfDefined(entity, simplified, 'descriptions');
    simplifyIfDefined(entity, simplified, 'aliases');
    simplifyIfDefined(entity, simplified, 'claims', options);
    simplifyIfDefined(entity, simplified, 'sitelinks', options);
  } else if (type === 'property') {
    simplified.datatype = entity.datatype;
    simplifyIfDefined(entity, simplified, 'labels');
    simplifyIfDefined(entity, simplified, 'descriptions');
    simplifyIfDefined(entity, simplified, 'aliases');
    simplifyIfDefined(entity, simplified, 'claims', options);
  } else if (type === 'lexeme') {
    simplifyIfDefined(entity, simplified, 'lemmas');
    simplified.lexicalCategory = entity.lexicalCategory;
    simplified.language = entity.language;
    simplifyIfDefined(entity, simplified, 'claims', options);
    simplifyIfDefined(entity, simplified, 'forms', options);
    simplifyIfDefined(entity, simplified, 'senses', options);
  }

  return simplified;
};

var simplifyIfDefined = function simplifyIfDefined(entity, simplified, attribute, options) {
  if (entity[attribute] != null) {
    simplified[attribute] = simplify[attribute](entity[attribute], options);
  }
};

var simplifyEntities = function simplifyEntities(entities) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (entities.entities) entities = entities.entities;
  var entityPrefix = options.entityPrefix;
  return Object.keys(entities).reduce(function (obj, key) {
    var entity = entities[key];
    if (entityPrefix) key = "".concat(entityPrefix, ":").concat(key);
    obj[key] = simplifyEntity(entity, options);
    return obj;
  }, {});
}; // Set those here instead of in ./simplify to avoid a circular dependency


simplify.entity = simplifyEntity;
simplify.entities = simplifyEntities;
module.exports = {
  simplifyEntity: simplifyEntity,
  simplifyEntities: simplifyEntities
};